module.exports = __webpack_public_path__ + "kudos_40.svg?d738bbffeab338b37feb9c86ceb89a77";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_40.svg
// module id = 140
// module chunks = 0